import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function GlobalSearch() {
  const [isSearchBarClicked, setIsSearchBarClicked] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')

  // Navigation items data
  const navigationItems = [
    { href: '/home', label: 'home' },
    { href: '/about', label: 'about' },
    { href: '/now', label: 'now' },
    { href: '/projects', label: 'projects' },
    { href: '/connect', label: 'connect' },
  ]

  // Filter navigation items based on search query
  const filteredItems = navigationItems.filter((item) =>
    item.label.toLowerCase().includes(searchQuery.toLowerCase()),
  )

  // Reset search when closing modal
  const handleCloseModal = () => {
    setIsSearchBarClicked(false)
    setSearchQuery('')
  }

  // Keyboard shortcut handler
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Check for Ctrl+K (Windows/Linux) or Cmd+K (Mac)
      if ((event.ctrlKey || event.metaKey) && event.key === 'k') {
        event.preventDefault() // Prevent default browser behavior
        setIsSearchBarClicked(true)
      }

      // Close modal with Escape key
      if (event.key === 'Escape' && isSearchBarClicked) {
        handleCloseModal()
      }
    }

    // Add event listener
    document.addEventListener('keydown', handleKeyDown)

    // Cleanup event listener
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [isSearchBarClicked]) // Dependency array includes isSearchBarClicked

  return (
    <>
      {/* Search Bar - Hidden on mobile */}
      <div className="fixed bottom-6 right-6 z-40 hidden md:block">
        <div className="relative">
          <input
            type="text"
            placeholder="Search portfolio"
            className="w-64 px-4 py-3 bg-black text-white placeholder-gray-400 rounded-2xl focus:outline-none transition-all duration-200 cursor-pointer text-sm"
            style={{ border: '0.3px solid #666666' }}
            onMouseEnter={(e) =>
              (e.target.style.border = '0.3px solid #E06100')
            }
            onMouseLeave={(e) =>
              (e.target.style.border = '0.3px solid #666666')
            }
            onClick={() => setIsSearchBarClicked(true)}
            readOnly
          />
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#E06100] text-xs">
            Ctrl+K
          </div>
        </div>
      </div>

      {/* Search Modal Popup */}
      {isSearchBarClicked && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-3 sm:p-4"
          onClick={handleCloseModal}
        >
          <div
            className="bg-black rounded-2xl sm:rounded-3xl shadow-2xl w-full max-w-sm sm:max-w-2xl max-h-[80vh] sm:max-h-96"
            style={{ border: '0.3px solid rgba(224, 97, 0, 0.4)' }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Search Input */}
            <div className="p-3 sm:p-4 border-b border-gray-800">
              <div className="relative">
                <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                  <svg
                    className="w-4 h-4 sm:w-5 sm:h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
                <input
                  type="text"
                  placeholder="Type a command or search..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-8 sm:pl-10 pr-10 sm:pr-12 py-2.5 sm:py-3 bg-transparent text-white placeholder-gray-400 border-none outline-none text-sm sm:text-base"
                  autoFocus
                />
                <button
                  onClick={handleCloseModal}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-white transition-colors"
                >
                  <svg
                    className="w-4 h-4 sm:w-5 sm:h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>

            {/* Navigation Dropdown */}
            <div className="p-3 sm:p-4">
              <div className="space-y-2">
                {filteredItems.length > 0 ? (
                  filteredItems.map((item) => (
                    <Link
                      key={item.href}
                      to={item.href}
                      className="flex items-center px-3 py-2 text-white hover:bg-gray-900 rounded-lg transition-colors duration-200"
                      onClick={handleCloseModal}
                    >
                      <span className="text-sm sm:text-base">{item.label}</span>
                    </Link>
                  ))
                ) : (
                  <div className="text-gray-400 text-sm sm:text-base px-3 py-2">
                    No results found
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
